import React from 'react';
import { Flex } from 'rebass';
import useJobPost from 'modules/JobPosts/hooks/useJobPost';
import JobBoardNavigation from 'modules/JobBoard/components/JobBoardNavigation';
import JobBoard from 'modules/JobBoard/components/JobBoard';
import Frame from 'components/Frame';
import { UserRoleType } from 'types/global';

interface JobBoardProps {
  userRole: UserRoleType;
}

const JobBoardPage: React.FC<any & JobBoardProps> = ({ userRole, match }): JSX.Element => {
  const { jobPost } = useJobPost(+match.params.id);
  return (
    <>
      {jobPost && (
        <Flex>
          <Frame>
            <Flex width="100%" flexDirection="column" pt={7}>
              <JobBoardNavigation
                userRole={userRole}
                userJobPost={jobPost}
                companyName={jobPost.companyName}
              />
              <JobBoard userRole={userRole} jobPostId={jobPost.id} />
            </Flex>
          </Frame>
        </Flex>
      )}
    </>
  );
};

export default JobBoardPage;
